import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Project } from 'app/interfaces/project.model';
import { SocialLink } from 'app/modules/social/models/social-link.model';
import { SocialService } from 'app/modules/social/services/social.service';
import { InstaService } from 'app/modules/social/services/insta.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-social-posts',
  templateUrl: './social-posts.component.html',
  styleUrls: ['./social-posts.component.scss'],
})
export class SocialPostsComponent implements OnInit {
  project: Project;
  socialItems: SocialLink[];
  preview: SocialLink;
  instaToken: string;
  instaResults: SocialLink[];

  constructor(private route: ActivatedRoute, private socialService: SocialService, private instaService: InstaService) {}

  ngOnInit() {
    this.instaToken = this.instaService.access_token;

    this.route.data.subscribe(a => {
      if (a) {
        this.project = a.project;
        this.socialItems = a.socialLinks;
      }
    });
  }

  handlePreview(url) {
    this.socialService
      .fetch(url)
      .pipe(first())
      .subscribe(a => (this.preview = a));
  }

  handleAdd(url) {
    this.socialService
      .add(url, this.project.Id)
      .pipe(first())
      .subscribe(a => (this.socialItems = [a, ...this.socialItems]));
  }

  handleDelete(id) {
    this.socialService
      .delete(this.project.Id, id)
      .pipe(first())
      .subscribe(a => (this.socialItems = a));
  }

  instaAuth() {
    this.instaService.startAuth();
  }

  setTab(tab) {
    localStorage.setItem('projectTab', tab);
  }

  searchInsta(q) {
    this.instaService.SearchByTag(q).subscribe(
      a => {
        this.instaResults = a.data.map(b => {
          const post: SocialLink = {
            Id: 0,
            Author: b.user.username,
            DateAdded: new Date(b.created_time),
            HostName: 'Instagram',
            ImageUrl: b.images.standard_resolution.url,
            Title: b.caption.text,
            Description: b.caption.text,
            SiteName: 'Instagram',
            Type: 'instagram',
            Url: b.link,
            Favicon: 'https://www.instagram.com/static/images/ico/favicon-192.png/b407fa101800.png',
            VideoUrl: b.videos ? b.videos.standard_resolution.url : null,
            ProjectId: 0,
          };

          return post;
        });
      },
      error => {
        console.log(error);
      }
    );
  }
}
